import React from 'react';
import { useTable, useSortBy, useFilters } from "react-table";
import Icon from '../ui/elements/Icon';
import Currency from '../ui/elements/Currency';



function Table({ columns, data }) {
  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
      columns,
      data,
      defaultColumn,
      initialState: {
        sortBy: [
          {
            id: 'name',
            desc: false
          }
        ]
      }
    },
    useFilters,
    useSortBy
  );

  return (
    <table className="table is-bordered is-striped" {...getTableProps()}>
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column, i) => (
            <th style={{ borderBottomWidth: 0 }}
              className="has-text-centered is-size-7 is-vertically-middle" key={i}
            >
              <div key="0" {...column.getHeaderProps(column.getSortByToggleProps({ title: 'Сортировать' }))}>
                {!column.disableSortBy ?
                  (<React.Fragment>
                    {column.render('Header')}{' '}<Icon icon={column.isSorted ? (column.isSortedDesc ? "caret-down" : "caret-up") : "sort"} />
                  </React.Fragment>)
                  :
                  column.render('Header')
                } </div>
            </th>
          ))}
        </tr>
      ))}
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column, i) => (
            <th style={{ borderTopWidth: 0 }}
              className="has-text-centered is-size-7 is-vertically-middle" key={i}
            >
              <div key="1">{column.canFilter ? column.render('Filter') : null}</div>
            </th>
          ))}
        </tr>
      ))}
      </thead>
      <tbody {...getTableBodyProps()}>
      {rows.map((row, i) => {
        prepareRow(row)
        return (
          <tr {...row.getRowProps()}>
            {row.cells.map(cell => {
              return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
            })}
          </tr>
        )
      })}
      </tbody>
    </table>
  );
}

function DefaultColumnFilter({
                               column: { filterValue, preFilteredRows, setFilter },
                             }) {

  return (
    <input
      className="input is-small"
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
      placeholder={`Поиск...`}
    />
  )
}

function NumberRangeColumnFilter({
                                   column: { filterValue = [], preFilteredRows, setFilter, id },
                                 }) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach(row => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <input
        value={filterValue[0] || ''}
        className="input is-small"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
        }}
        placeholder={`${min}`}
        style={{
          width: '55px',
          marginRight: '0.3rem',
        }}
      />
      —
      <input
        value={filterValue[1] || ''}
        className="input is-small"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
        }}
        placeholder={`${max}`}
        style={{
          width: '55px',
          marginLeft: '0.3rem',
        }}
      />
    </div>
  )
}

function SelectColumnFilter({
                              column: { filterValue, setFilter, preFilteredRows, id }
                            }) {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach(row => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <div className="select">
      <select
        value={filterValue}
        onChange={e => {
          setFilter(e.target.value || undefined);
        }}
      >
        <option value="">Все регионы</option>
        {options.filter((o) => o != '').sort().map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

class Clients extends React.Component {
  constructor(props) {
    super(props);

    const sdata = [];
    this.props.clients.map((client, i) =>
      sdata.push({
        name: client.name,
        inn: client.inn,
        qty: client.qty,
        region: client.region,
        variants: client.variants,
        date: client.date,
        parts: client.parts,
        sto: client.sto,
        comment: client.comment,
        partsComment: client.partsComment,
        stoComment: client.stoComment
      })
    );


    this.state = {
      data: sdata
    }
  }

  render() {
    const columns = [
      {
        Header: 'Клиент',
        accessor: 'name',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-vertically-middle">
              {value}
            </p>
          );
        },
        sortType: 'basic'
      },
      {
        Header: 'ИНН',
        accessor: 'inn',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered is-vertically-middle">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Количество',
        accessor: 'qty',
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered is-vertically-middle">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Регион',
        accessor: 'region',
        Filter: SelectColumnFilter,
        filter: "includes",
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered is-size-7">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Варианты комплектации',
        disableSortBy: true,
        accessor: 'variants',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-size-7">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Дата последней отгрузки / передачи в тест',
        disableFilters: true,
        accessor: 'date',
        sortType: (a, b) => {
          let a_parts = a.values.date.split('.');
          let b_parts = b.values.date.split('.');
          return new Date(a_parts[2], a_parts[1] - 1, a_parts[0]) - new Date(b_parts[2], b_parts[1] - 1, b_parts[0]);
        },
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Продажа запчастей (руб. с НДС)',
        accessor: 'parts',
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-nowrapped has-text-right"><Currency value={Math.round(value)} /></p>
          );
        }
      },
      {
        Header: 'Продажи через СТО (руб. с НДС)',
        accessor: 'sto',
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-nowrapped has-text-right"><Currency value={Math.round(value)} /></p>
          );
        }
      },
      {
        Header: () => (<div>Комментарий<br></br>отдела продаж</div>),
        accessor: 'comment',
        disableSortBy: true,
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: () => (<div>Комментарий<br></br>отдела зачастей</div>),
        accessor: 'partsComment',
        disableSortBy: true,
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: () => (<div>Комментарий<br></br>сервиса</div>),
        accessor: 'stoComment',
        disableSortBy: true,
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      }
    ];


    return (
      <div className="shipment_parts_table">
        <Table columns={columns} data={this.state.data} />
      </div>
    );
  }
}

Clients.propTypes = {};

export default Clients;
